import styled from 'styled-components';

import { HealthProfileUpdateStepNames } from './constants';

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.s4};
  padding-bottom: 0 !important;
  & label {
    white-space: pre-line;
  }
`;

// A negative margin div to offset the SimpleLayoutContainer bottom margin on the header
export const NegativeMarginOffset = styled.div`
  margin-top: -${({ theme }) => (theme.mediaQueries.small ? theme.space.s7 : 0)};
`;

export const HealthProfileFormHeaderAdjustment = styled.div<{
  currentStepName: HealthProfileUpdateStepNames;
}>`
  ${({ currentStepName, theme }) =>
    [
      HealthProfileUpdateStepNames.Confirmation,
      HealthProfileUpdateStepNames.GotIt,
      HealthProfileUpdateStepNames.JustSayCapsule,
    ].includes(currentStepName) && !!theme.mediaQueries.smallDown
      ? ''
      : `
          position: absolute;
          top: 0;
          z-index: ${theme.zIndex.z3};
        `}
`;

export const GreenFont = styled.div`
  color: ${({ theme }) => theme.colors.capsuleGreen60};
`;

export const GreenFontWithRedError = styled.div<{ hasError: boolean }>`
  color: ${({ theme, hasError }) => (hasError ? theme.colors.capsuleRed60 : theme.colors.capsuleGreen60)};
`;
